import { type AssetPosition, periodEnum } from "kubb";
import type React from "react";
import ReceiverAssignmentTable from "./ReceiverAssignmentTable";
import WirelessRFDataApiWrapper from "./WirelessRFDataApiWrapper";

export default function WirelessClusterReceiverAssignmentTab(props: {
  clusterPosition: AssetPosition;
}): React.ReactElement {
  const { clusterPosition } = props;
  return (
    <>
      <WirelessRFDataApiWrapper
        request={{
          company_id: clusterPosition.company_id,
          scheme_id: clusterPosition.scheme_id,
          period: periodEnum.ALL,
          parent_asset_position_id: clusterPosition.asset_position_id,
        }}
      >
        {(props) => (
          <ReceiverAssignmentTable
            {...props}
            wirelessCluster={clusterPosition}
          />
        )}
      </WirelessRFDataApiWrapper>
    </>
  );
}
